<template>
  <div class="back-top" id="goTop" @click="goTop">
    <span class="el-icon-arrow-up"></span>
  </div>
</template>

<script>
/* eslint-disable */
export default {
  name: 'toTop',
  data() {
    return {
      scrollTop: '',
      goTopShow: false,
    };
  },
  methods: {
    handleScroll() {
      this.scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
      if (this.scrollTop > 800) {
        this.goTopShow = true;
      } else {
        this.goTopShow = false;
      }
    },
    goTop() {
      let timer = null; const
        _that = this;
      cancelAnimationFrame(timer);
      timer = requestAnimationFrame(function fn() {
        if (_that.scrollTop > 0) {
          _that.scrollTop -= 100;
          document.body.scrollTop = document.documentElement.scrollTop = _that.scrollTop;
          timer = requestAnimationFrame(fn);
        } else {
          cancelAnimationFrame(timer);
          _that.goTopShow = false;
        }
      });
    },
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll);
  },
  destroyed() {
    window.removeEventListener('scroll', this.handleScroll);
  },
};
</script>

<style scoped>
  .back-top{
    position: fixed;
    width: 40px;
    height: 40px;
    text-align: center;
    line-height: 40px;
    border-radius: 50%;
    background: #999;
    bottom: 60px;
    right: 30px;
    z-index: 19999;
    font-size: 30px;
    cursor: pointer;
    color: #fff;
    transition: box-shadow .3s;
  }
  .back-top:hover{
    box-shadow: 0 0 6px rgba(0,0,0,.5);
  }
</style>
